module.exports = __webpack_public_path__ + "images/psp/Bicycle/10x10.svg";